<template>
  <div class="main">
    <h2 class="conTitle">前端导航</h2>
    <!--<el-button type="primary">主要按钮</el-button>-->

    <el-collapse v-model="activeName" accordion>
      <el-collapse-item v-for="item in linksData" :key="item.id" :title="item.typeName" :name="item.typeName">
        <ul class="linkItems clearfix">
          <li class="linkItem" v-for="i in item.data"><a target="_blank" :href="i.linkUrl">{{i.linkName}}</a></li>
        </ul>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  import {blogsSDK} from '../assets/js/blogsSDK'

  export default {
    name: 'links',
    data() {
      return {
        title: '导航',
        activeName: '',
        // linksData: {}
      }
    },
    components: {},
    computed: {
      linksData() {
        return this.$store.state.linksData.links||[]
      }/*,
      activeName() {
        if (this.$store.state.linksData.links){
          return this.$store.state.linksData.links[0].typeName
        }else{
          return ''
        }
      }*/
    },
    beforeCreate: function () {
      let _that = this;
      //获取导航信息
      console.log(22222222,this)
      if (!_that.$store.state.linksData.links){
        this.$http.get(blogsSDK.serverHost + '/data/linksData.json',
        ).then((response) => {
          _that.$store.commit('linksDataSet', response.body);
          // _that.$store.dispatch('linksDataSet', response.body);
          _that.activeName = response.body.links[0].typeName;
        }).catch(function (response) {
          console.log(response)
        });
      }else {

      }

      console.log(3333333,this)
    },
    mounted:function () {
      window.document.title='导航 - 曲奇的小桃酥';
      if (this.$store.state.linksData.links){
        this.activeName = this.$store.state.linksData.links[0].typeName
      }
    }
  }
</script>
<style lang="scss">
  .main {
    .conTitle {
      font-size: 32px;
      margin-bottom: 25px;
      font-weight: 300;
    }
    .el-collapse-item__wrap,.el-collapse-item__header{
      background-color: transparent;
      /*color: #2479cc;*/
    }
    .el-collapse, .el-collapse-item__header, .el-collapse-item__wrap{
      border-color: #000;
    }
    .el-collapse-item__header{
      font-size: 16px;
      font-weight: bold;
    }
    .linkItems{
      .linkItem{
        float: left;
        a{
          display: block;
          min-width: 55px;
          margin: 10px 15px 10px 0;
          padding: 5px 10px;
          border: 1px solid #2479cc;
          border-radius: 28px;
          color: #2479CC;
          text-align: center;
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/links.vue